"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    pascalCase: function() {
        return pascalCase;
    },
    titleCase: function() {
        return titleCase;
    }
});
const _interop_require_default = require("@swc/helpers/_/_interop_require_default");
const _camelCase = /*#__PURE__*/ _interop_require_default._(require("lodash/camelCase"));
const _startCase = /*#__PURE__*/ _interop_require_default._(require("lodash/startCase"));
function titleCase(input) {
    if (!input) return '';
    return (0, _startCase.default)((0, _camelCase.default)(input));
}
function pascalCase(input) {
    return titleCase(input).replace(/ /g, '');
}

//# sourceMappingURL=case.js.map